import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72dc1f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-to-partner-box" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "Approved requests", -1))
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestPartnerListFilter = _resolveComponent("RequestPartnerListFilter")!
  const _component_PartnerRequestApprovedListItem = _resolveComponent("PartnerRequestApprovedListItem")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createVNode(_component_white_box_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_RequestPartnerListFilter, {
                value: _ctx.filterBy,
                onHandleValueChange: _ctx.setFilter
              }, null, 8, ["value", "onHandleValueChange"])
            ]),
            (_ctx.reviewRequest().length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No Data"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvedRequest, (data, index) => {
              return (_openBlock(), _createBlock(_component_PartnerRequestApprovedListItem, {
                key: data.id,
                data: data,
                index: index + 1
              }, null, 8, ["data", "index"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}